import React, { useEffect, useState } from 'react';
import { Breadcrumb, Layout, theme, Row, Col, Form, Button, Modal, Select, Input, Typography, Table, Tag, Space, Switch, Tooltip, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../usableclasses.js';
const { Content } = Layout;
const { Option } = Select;
const { Title, Text } = Typography;

function Subcategories() {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();
    const navigate = useNavigate();
    const { categoryId } = useParams();
    
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [subcategories, setSubcategories] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editSubcategory, setEditSubcategory] = useState(null);
    const [filteredSubcategories, setFilteredSubcategories] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [categoryName, setCategoryName] = useState('');

   
    const fetchCategoryDetails = () => {
      
        const storedCategoryName = localStorage.getItem(`categoryName_${categoryId}`);
        if (storedCategoryName) {
            setCategoryName(storedCategoryName);
        } else {
            setCategoryName('Category ' + categoryId);
        }
    };

    useEffect(() => {
        
        if (categoryId) {
            setSubcategories([]);
            setFilteredSubcategories([]);
            setKeyword('');
            fetchCategoryDetails();
            fetchSubcategories();
        } 
        
    }, [categoryId]);

    const fetchSubcategories = async () => {
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/master/subcategory/listbycategoryid/${categoryId}`, { headers });
            setSubcategories(response.data);
            setFilteredSubcategories(response.data);
        } catch (error) {
            AlertError("Failed to fetch subcategories");
        }
    };

    const showModal = () => {
        setIsModalOpen(true);
    };

    const showEditModal = (subcategory) => {
        setEditSubcategory(subcategory);
        form.setFieldsValue({
            subCategoryName: subcategory.subCategoryName,
            subCategoryActiveStatus: subcategory.subCategoryStatus
        });
        setIsEditModalOpen(true);
    };
    
    const handleCancel = () => {
        setIsModalOpen(false);
        setIsEditModalOpen(false);
        form.resetFields();
    };

    const handleCreateSubcategory = async () => {
        try {
            const values = await form.validateFields();

            const requestData = {
                categoryId: parseInt(categoryId),
                // Change from subCategoryName to subcategoryName (lowercase 'c')
                subCategoryName: values.subcategoryName
            };

            const headers = {
                SystemAccessToken: TOKEN,
                "Content-Type": "application/json",
            };

            const response = await axios.post(
                `${ApiURL}/master/subcategory/create`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Subcategory successfully added!");
                handleCancel();
                fetchSubcategories();
            }
        } catch (error) {
            AlertError(error.response?.data?.message || "Failed to add subcategory!");
        }
    };

    const handleUpdateSubcategory = async () => {
        try {
            const values = await form.validateFields();
            
            const requestData = {
                subCategoryId: editSubcategory.subCategoryId,
                categoryId: parseInt(categoryId),
                subCategoryName: values.subCategoryName,  // Remove the .tostring() which was causing an error
                subCategoryActiveStatus: values.subCategoryActiveStatus
            };

            const headers = { 
                SystemAccessToken: TOKEN,
                "Content-Type": "application/json"
            };
            
            const response = await axios.post(
                `${ApiURL}/master/subcategory/edit`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Subcategory successfully updated!");
                handleCancel();
                fetchSubcategories();
            }
        } catch (error) {
           
            AlertError(error.response?.data?.message || "Failed to update subcategory!");
        }
    };

    const handleDeleteSubcategory = async (id) => {
        try {
            
            const headers = { 
                SystemAccessToken: TOKEN,
                "Content-Type": "application/json"
            };
            
            // Using the exact API endpoint format specified
            const response = await axios.get(
                `${ApiURL}/master/subcategory/delete/${id}`,
                { headers }
            );
            
            if (response.status === 200) {
                AlertSuccess("Subcategory deleted successfully!");
                fetchSubcategories(); // Refresh the list
            } else {
                AlertError("Failed to delete subcategory. Unexpected response.");
            }
        } catch (error) {
            
            AlertError(error.response?.data?.message || "Failed to delete subcategory!");
        }
    };

    const handleFilter = () => {
        if (keyword) {
            const filtered = subcategories.filter(subcategory => 
                subcategory.subCategoryName.toLowerCase().includes(keyword.toLowerCase())
            );
            setFilteredSubcategories(filtered);
        } else {
            setFilteredSubcategories(subcategories);
        }
    };

    const handleReset = () => {
        setKeyword('');
        setFilteredSubcategories(subcategories);
    };

    const goBackToCategories = () => {
        navigate('/master/categories');
    };

    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            fixed: 'left',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button type="link" icon={<EditOutlined />} onClick={() => showEditModal(record)} />
                    </Tooltip>
                    <Popconfirm
                        title="Are you sure to delete this subcategory?"
                        onConfirm={() => handleDeleteSubcategory(record.subCategoryId)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip title="Delete">
                            <Button type="link" danger icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            ),
        },
        {
            title: 'Subcategory Name',
            dataIndex: 'subCategoryName', 
            key: 'subCategoryName', 
            sorter: (a, b) => a.subCategoryName.localeCompare(b.subCategoryName),
            align: "center",
        },
        {
            title: 'Status',
            dataIndex: 'subCategoryStatus', 
            key: 'subCategoryStatus',
            render: (status) => (
                <Tag color={status === true ? "green" : "red"}>
                    {status === true ? "Active" : "Inactive"}
                </Tag>
            ),
            align: "center",
        },
    ];

    return (
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: '10px', }} >
                <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item>Master</Breadcrumb.Item>
                    <Breadcrumb.Item><Link to={'/master/categories'}>Categories</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>Subcategories</Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG, }} >
                    <Space
                        direction="vertical"
                        style={{ width: "100%", padding: "15px" }}
                    >
                                              <Row style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Col>
                                <Typography.Title level={4} style={{ margin: 0 }}>
                                    Category: {categoryName}
                                </Typography.Title>
                            </Col>
                            <Col>
                                <Space>
                                    <Button 
                                        type="default" 
                                        icon={<ArrowLeftOutlined />}
                                        onClick={goBackToCategories}
                                    >
                                        Go back to Categories
                                    </Button>
                                    <Button type="primary" onClick={showModal}>Create New</Button>
                                </Space>
                            </Col>
                        </Row>
                        
                        <Row style={{display:"flex", justifyContent:'space-between', marginBottom: '15px'}}>
                            <Col xs={24} md={12}>
                                <Input
                                    placeholder="Search by keyword"
                                    value={keyword}
                                    onChange={(e) => setKeyword(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </Col>
                            <Col xs={24} md={8} style={{display:"flex", justifyContent:'flex-end'}} className="mt-2 mt-md-0">
                                <Button type="primary" onClick={handleFilter} style={{ width: "50%", margin:"0" }}>Filter</Button>
                                <Button style={{ marginLeft: '10px', width: "50%" }} onClick={handleReset}>Reset</Button>
                            </Col>
                        </Row>
                        <Typography.Title level={5}>List of Subcategories for {categoryName}</Typography.Title>
                        <Table
                            columns={columns}
                            dataSource={filteredSubcategories}
                            rowKey="subcategoryId"
                            pagination={{ pageSize: 5 }}
                            scroll={{ x: 600 }}
                        />
                    </Space>
                </div>
            </Content>
            <Footerdiv />
            <Modal
                title="Create New Subcategory"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="create" type="primary" onClick={handleCreateSubcategory}>
                        Create
                    </Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Subcategory Name"
                        name="subcategoryName"
                        rules={[{ required: true, message: "Subcategory name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Edit Subcategory"
                open={isEditModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                    <Button key="update" type="primary" onClick={handleUpdateSubcategory}>Update</Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Subcategory Name"
                        name="subCategoryName"
                        rules={[{ required: true, message: "Subcategory name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Active Status"
                        name="subCategoryActiveStatus"
                        valuePropName="checked"
                    >
                        <Switch />
                    </Form.Item>
                </Form>
            </Modal>
        </Layout>
    );
}

export default Subcategories;
